import {
  Box,
  Card,
  Grid,
  Icon,
  TextField,
  Typography,
} from "@mui/material";
import DeleteIcon from "common/customIcons/delete";
import CommonQuillEditor from "common/editor";
import MDButton from "components/MDButton";
import React, { useEffect, useState } from "react";
import { grey } from "@mui/material/colors";
import EditIcon from "common/customIcons/edit";

import { useDispatch } from "react-redux";
import { updateProductSeo } from "../../../redux/slices/products";
import { openSnackbar } from "../../../redux/slices/common";
import { fetchSingleProduct } from "../../../redux/slices/hyperwolf/products";
const SeoContent = ({ productDetails }) => {
  const dispatch = useDispatch();
  const initialState = {
    metaDescription: "",
    metaTitle: "",
    content: "",
    faq: [
      {
        // question: "",
        // answer: "",
      },
    ],
  };
  const [isEdit, setIsEdit] = useState(false);
  const [faqError, setFaqError] = useState("");
  const [formData, setFormData] = useState({ ...initialState });
  const [errors, setErrors] = useState({
    metaTitle: "",
    metaDescription: "",
  });
  const isQuillContentEmpty = (html = "") => {
    const text = html
      .replace(/<(.|\n)*?>/g, "") // remove tags
      .replace(/&nbsp;/g, "")
      .trim();

    return text.length === 0;
  };

  const isLastFAQFilled = () => {
    const faqs = formData.faq || [];
    if (faqs.length === 0) return true;

    const last = faqs[faqs.length - 1];
    return Boolean(
      (last?.question && last.question.trim() !== "") || (last?.answer && last.answer.trim() !== "")
    );
  };

  const handleRemoveFAQ = (faQIdx) => {
    let FAQArray = [...(formData?.faq || [])];
    FAQArray = FAQArray.filter((faqs, _idx) => _idx !== faQIdx);
    setFormData({
      ...formData,
      faq: FAQArray,
    });
  };


  const addFAQHandler = () => {
    if (!isLastFAQFilled()) {
      setFaqError("Please fill the previous FAQ before adding a new one.");
      return;
    }
    setFaqError("");
    let newFAQ = [...(formData?.faq || [])];
    let faqItem = {
      // question: "",
      // answer: "",
    };
    newFAQ.push(faqItem);
    setFormData({
      ...formData,
      faq: newFAQ,
    });
  };
  const handleChangeFAQ = (value, fieldType, idx) => {
    let FAQArray = [...(formData?.faq || [])];
    if (FAQArray[idx]) {
      FAQArray[idx] = {
        ...FAQArray[idx],
        [fieldType]: value,
      };
      setFormData({
        ...formData,
        faq: FAQArray,
      });
    }
  };

  useEffect(() => {
    setFormData({
      metaTitle: productDetails?.metaTitle,
      metaDescription: productDetails?.metaDescription,
      content: productDetails?.content,
      faq: Array.isArray(productDetails?.faq) ? productDetails.faq : [],
    });
  }, [productDetails]);

  const validateForm = () => {
    let newErrors = {};

    if (!formData.metaTitle?.trim()) {
      newErrors.metaTitle = "Meta title is required";
    }

    if (!formData.metaDescription?.trim()) {
      newErrors.metaDescription = "Meta description is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    try {
      const payload = {
        metaTitle: formData.metaTitle,
        metaDescription: formData.metaDescription,
        content: formData.content,
        faq: formData.faq?.filter(
          (f) => !isQuillContentEmpty(f?.question) || !isQuillContentEmpty(f?.answer)
        ),
      };
      await dispatch(updateProductSeo({ productId: productDetails.productId, data: payload }))
        .unwrap()
        .then((res) => {
          showError(res?.message, "success");
          const productId = productDetails.productId;
          dispatch(fetchSingleProduct(productId)); //refresh products
        })
        .catch((err) => {
          showError(err?.message || "Save failed", "error");
        });

      setIsEdit(false);
    } catch (error) {
    }
  };
  const showError = (message, errortype) => {
    if (errortype === "success") {
      dispatch(openSnackbar({ content: message, color: "success", icon: "check" }));
    }
    if (errortype === "error") {
      dispatch(openSnackbar({ content: message, color: "error", icon: "warning" }));
    }
  };
  const cardSx = { p: { xs: 2, md: 3 }, mb: 3, borderRadius: 2.5, boxShadow: "none" };

  return (
    <>

      {/* Section 2: FAQs – separate card with border */}
      <Card sx={cardSx}>
        <Typography variant="subtitle1" fontWeight="600" sx={{ mb: 2 }}>
          FAQs
        </Typography>
        {isEdit ? (
          <>
            {formData?.faq?.length > 0 ? (
              <>
                {formData?.faq?.map((faqs, idx) => {
                  return (
                    <Grid key={idx} item xs={12} sm={12} lg={12} my={2}>
                      <Box width={"100%"} className="faq-sec-rep">
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="space-between"
                          alignItems={"flex-start"}
                          className="mb-3"
                        >
                          <Box
                            width={"100%"}
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            mb={1}
                          >
                            <Typography variant="body2" fontWeight="medium" color={grey[600]}>
                              Question
                            </Typography>
                            <MDButton
                              sx={{ minWidth: "auto", p: 0 }}
                              size="small"
                              variant="text"
                              onClick={() => handleRemoveFAQ(idx)}
                              style={{ color: "#fd4438" }}
                            >
                              <DeleteIcon width="1rem" height="1rem" style={{ color: "#fd4438" }} />{" "}
                            </MDButton>
                          </Box>
                          <Box width={"100%"}>
                            <CommonQuillEditor
                              allowHeading={false}
                              allowImage={false}
                              value={faqs?.question || ""}
                              onChange={(value) => {
                                handleChangeFAQ(value, "question", idx);
                                setFaqError("");
                              }}
                            />
                          </Box>
                        </Box>
                        <Box display="flex" justifyContent="center" alignItems={"flex-start"}>
                          <Box width={"100%"}>
                            <Typography variant="body2" fontWeight="medium" color={grey[600]} mb={1}>
                              Answer
                            </Typography>
                            <CommonQuillEditor
                              allowHeading={false}
                              allowImage={false}
                              value={faqs?.answer || ""}
                              onChange={(value) => {
                                handleChangeFAQ(value, "answer", idx);
                                setFaqError("");
                              }}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                  );
                })}
              </>
            ) : (
              <Grid item xs={12} sm={12} lg={12} mt={3}>
                <Box display="flex" justifyContent="space-between" alignItems={"center"}>
                  <MDButton
                    type="button"
                    color="primary"
                    size="medium"
                    variant="outlined"
                    sx={{ minWidth: "180px" }}
                    onClick={addFAQHandler}
                  >
                    <Icon>add</Icon>&nbsp;Add FAQ
                  </MDButton>
                </Box>
              </Grid>
            )}
            {faqError && (
              <Typography color="error" variant="body2" mb={1}>
                {faqError}
              </Typography>
            )}

            {formData?.faq?.length > 0 && (
              <Grid item xs={12} mt={3}>
                <MDButton
                  type="button"
                  color="primary"
                  size="medium"
                  variant="outlined"
                  sx={{ minWidth: "180px" }}
                  onClick={addFAQHandler}
                >
                  <Icon>add</Icon>&nbsp;Add More
                </MDButton>
              </Grid>
            )}
          </>
        ) : (
          <>
            {Array.isArray(formData.faq) && formData.faq.length > 0 ? (
              formData.faq.map((faqs, idx) => (
                <Box key={idx} mb={3}>
                  <Typography variant="body1" fontWeight="500" component="div" sx={{ mb: 0.5 }}>

                    <span dangerouslySetInnerHTML={{ __html: faqs?.question || "-" }} />
                  </Typography>
                  <Typography variant="body1" fontWeight="500" component="div" color="text.secondary" dangerouslySetInnerHTML={{ __html: faqs?.answer || "-" }} />
                </Box>
              ))
            ) : (
              <Typography variant="body2" color="text.secondary">No FAQs added</Typography>
            )}
          </>
        )}

        {isEdit && (
          <Box display="flex" justifyContent="flex-start" gap={2} mt={4}>
            <MDButton
              size="medium"
              variant="contained"
              color="primary"
              sx={{ width: 160 }}
              onClick={handleSave}
            >
              Save
            </MDButton>
            <MDButton
              size="medium"
              variant="outlined"
              color="error"
              sx={{ width: 160 }}
              onClick={() => {
                setIsEdit(false);
                dispatch(fetchSingleProduct(productDetails.productId));
              }}
            >
              Cancel
            </MDButton>
          </Box>
        )}
      </Card>
      {/* Section 1: Meta Properties – separate card */}
      <Card sx={cardSx}>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
          <Typography variant="subtitle1" fontWeight="600" sx={{ mb: 2 }}>
            Meta Properties
          </Typography>

        </Box>

        {isEdit ? (
          <Grid container spacing={2.5}>
            <Grid item xs={12} sm={6} lg={4}>
              <TextField
                label="Meta Title"
                value={formData.metaTitle || ""}
                fullWidth
                variant="outlined"
                error={Boolean(errors.metaTitle)}
                helperText={errors.metaTitle}
                onChange={(e) => {
                  const value = e.target.value;
                  setFormData((prev) => ({ ...prev, metaTitle: value }));
                  setErrors((prev) => ({
                    ...prev,
                    metaTitle: value.trim() === "" ? "Meta title is required" : "",
                  }));
                }}
              />
              <span className="drag_drop">
                Character Count: {formData?.metaTitle?.length || 0}{" "}
                <span>(Recommended Characters: 60)</span>
              </span>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Meta Description"
                value={formData.metaDescription}
                fullWidth
                rows={4}
                variant="outlined"
                error={Boolean(errors.metaDescription)}
                helperText={errors.metaDescription}
                onChange={(e) => {
                  const value = e.target.value;
                  setFormData((prev) => ({ ...prev, metaDescription: value }));
                  setErrors((prev) => ({
                    ...prev,
                    metaDescription: value.trim() === "" ? "Meta description is required" : "",
                  }));
                }}
              />
              <span className="drag_drop">
                Character Count: {formData?.metaDescription?.length || 0}{" "}
                <span>(Recommended Characters: 160)</span>
              </span>
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={2.5}>
            <Grid item xs={12}>
              <Typography variant="body2" color={grey[600]} gutterBottom>
                Meta Title
              </Typography>
              <Typography variant="body1" fontWeight="500" >
                {formData.metaTitle || "-"}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" color={grey[600]} gutterBottom>
                Meta Description
              </Typography>
              <Typography variant="body1" fontWeight="500" sx={{ mb: 2 }}>
                {formData.metaDescription || "-"}
              </Typography>
            </Grid>
          </Grid>
        )}

        <Typography variant="body2" color={grey[600]} gutterBottom>
          Content Section
        </Typography>
        {isEdit ? (
          <CommonQuillEditor
            value={formData?.content || ""}
            allowHeading={false}
            onChange={(value) => setFormData({ ...formData, content: value })}
          />
        ) : (
          <Box sx={{ mb: 0 }}>
            <Typography
              component="div"
              variant="body2"
              fontWeight="500"
              dangerouslySetInnerHTML={{ __html: formData?.content || "-" }}
            />
          </Box>
        )}
      </Card>


    </>
  );
};

export default SeoContent;
